/**
 * Header Class
 * @class Header
 */

export default class Header {
    constructor() {
        this.body = document.querySelector('body');
        // Navi
        this.elem = document.querySelector('.navbar');
        this.naviOpenClass = 'navbar--open';
        this.naviItemOpenClass = 'navbar--item-open';
        this.naviWrapper = document.querySelector('.navbar-collapse__wrapper');
        this.menuItems = document.querySelectorAll('.menu-level-0 > .menu-item');
        this.menuItemOpenClass = 'menu-item--open';
        this.firstMenuItem = document.querySelector('.menu-level-0 > .menu-item:first-child');
        this.burgerBtn = document.querySelector('.navbar-toggle-js-dkp');
        this.closeBtnMobile = document.querySelector('.navbar-toggle-js-mobile');
        this.backBtn = document.querySelector('.navi-back-btn');

        // Search input
        this.searchInput = document.querySelector('.navbar__search');
        this.searchBtns = document.querySelectorAll('.search-item > span');
        this.searchInputShowClass = 'navbar__search--show-search';

        // Variable
        this.isDesktop;

        // Load events
        this.eventsNavi();
        this.menuItemsEvents();
        this.eventSearchInput();
        this.backBtnEvents();
    }

    eventsNavi() {
        this.burgerBtn.addEventListener('click', () => {
            if ( this.isNaviOpen() ) {
                this.closeNavi();
            } else {
                this.openNavi();
            }
        });

        if (window.matchMedia("(min-width: 1024px)").matches) {
            this.isDesktop = true;
        } else {
            this.isDesktop = false;
        }

        this.closeBtnMobile.addEventListener('click', () => {
            this.closeNavi();
        });
    }
    
    resizeEvent() {
        if (window.matchMedia("(min-width: 1024px)").matches && !this.isDesktop) {
            this.isDesktop = true;
            this.closeMenuItem();
            this.openMenuItem();
        } else if (window.matchMedia("(max-width: 1023px)").matches && this.isDesktop) {
            this.isDesktop = false;
        }
    }

    menuItemsEvents() {
        this.menuItems.forEach(item => {
            item.querySelector('a').addEventListener('click', (e) => {
                e.preventDefault();
                this.closeMenuItem();
                this.openMenuItem(item);
            })
        })
    }

    isNaviOpen() {
        return this.elem.classList.contains(this.naviOpenClass) ? true : false;
    }

    isSearchOpen() {
        return this.searchInput.classList.contains(this.searchInputShowClass) ? true : false;
    }

    openNavi() {
        window.addEventListener('resize', () => {
            this.resizeEvent();
        });

        this.elem.classList.add(this.naviOpenClass);
        this.body.classList.add('body--fixed');

        if( this.isSearchOpen()) {
            this.closeSearchItem();
        }

        if (window.matchMedia("(min-width: 1024px)").matches) {
            this.openMenuItem();
        }
    }
    
    closeNavi() {
        window.removeEventListener('resize', this.resizeEvent);
        this.elem.classList.remove(this.naviOpenClass);
        this.body.classList.remove('body--fixed');
        this.closeMenuItem();
    }
    
    openMenuItem(item = this.firstMenuItem) {
        this.elem.classList.add( this.naviItemOpenClass);
        item.classList.add(this.menuItemOpenClass);
    }
    
    closeMenuItem() {
        this.menuItems.forEach(item => {
            item.classList.remove(this.menuItemOpenClass);
        });

        this.elem.classList.remove(this.naviItemOpenClass);   
    }

    openSearchItem() {
        if ( this.isNaviOpen()) {
            this.closeNavi();
        }
        
        this.searchInput.classList.add(this.searchInputShowClass);
    }

    closeSearchItem() {
        this.searchInput.classList.remove(this.searchInputShowClass);
    }

    eventSearchInput() {
        this.searchBtns.forEach( btn => {
            btn.addEventListener('click', () => {
                if ( this.isSearchOpen() ) {
                    this.closeSearchItem();
                } else {
                    this.openSearchItem();
                }
            });
        });
    }

    backBtnEvents() {
        this.backBtn.addEventListener('click', () => {
            this.elem.classList.remove(this.naviItemOpenClass);
            this.closeMenuItem();
        });
    }
}